export default __webpack_public_path__ + "static/media/ProgressStage2.f8978c4f.svg";